<template>
  <div class="comp_body_signin" style="width:400px">
    <div>
      <img src="/static/img/hljodbok-@1x-400.png">
    </div>
    <div>
      <input type="text"  placeholder="Notandanafn" v-model="username" v-on:keyup.enter="on_username_enter">
    </div>
    <div>
      <input type="password" ref="password" placeholder="Lykilorð" v-model="password" v-on:keyup.enter="on_password_enter">
    </div>
    <div>
      <input type="button"  value="INNSKRÁ"  v-on:click="on_signin_click">
    </div>
    <h4 style="margin-top:30px">Ekkert notandanafn?</h4>
    <div>
      Stofnaðu aðgang og kauptu <a class="link2" href="https://www.forlagid.is/voruflokkur/hljodbaekur-og-tonlist/streymi/">Hljóðbók - streymi á heimasíðu Forlagsins</a> og þá birtist bókin í appinu.
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import * as srv from '../srv'
import * as storage from '../storage'
export default {
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    on_username_enter () {
      this.$refs.password.focus()
    },
    on_password_enter () {
      this.sign_in()
    },
    on_signin_click () {
      this.sign_in()
    },
    sign_in () {
      srv.signin(this.username, this.password)
        .then(data => {
          console.log(data.fullname)
          storage.set_browser_id(data.browser_id)
          storage.set_user_id(data.user_id)
          storage.user.username = data.username
          storage.user.fullname = data.fullname
          this.username = ''
          this.password = ''
          this.$emit('show-assets')
        })
        .catch(srv_err => {
          this.$emit('dialog-message', srv_err.error_text, () => {})
        })
    }
  }
}
</script>
<<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Signin.vue